module.exports = __webpack_public_path__ + "static/media/dp.b0073848.jpeg";